var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAppointmentClinicsPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#FFF8ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.743 66.596V31.957l-15.888 1.094h-.02v33.545h15.908ZM67.144 33.051l-15.888-1.094v34.639h15.907V33.05c-.006 0-.012.004-.019 0Z",
    fill: "#FFE0AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.82 31.02c0 1.114.907 2.021 2.016 2.03h14.808v-4.06H16.855a2.04 2.04 0 0 0-2.035 2.03ZM52.355 28.991v4.06h14.808a2.037 2.037 0 0 0 2.016-2.03 2.04 2.04 0 0 0-2.035-2.03H52.355ZM16.836 35.588h11.299c1.626 0 1.349.845 1.349 2.487v28.52h2.16V33.051H16.835v2.537Z",
    fill: "#FFC26F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.466 31.021a2.037 2.037 0 0 1-2.016 2.03h2.714a2.037 2.037 0 0 0 2.016-2.03 2.04 2.04 0 0 0-2.034-2.03h-2.714a2.04 2.04 0 0 1 2.034 2.03Z",
    fill: "#FFD76F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.144 33.05H52.356v2.538h10.762c.935 0 1.33-.019 1.33 1.004v30.003h2.715V33.051h-.019Z",
    fill: "#FFC26F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.357 23.465 41.69 22.222l-10.047 1.243v43.13h4.341V54.1h12.031v12.495h4.34V23.465Z",
    fill: "#F9F7F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.566 47.533h7.348v4.673h-7.348v-4.673ZM20.566 37.712h7.348v4.673h-7.348v-4.673ZM56.082 37.712h7.35v4.673h-7.35v-4.673ZM56.082 47.533h7.35v4.673h-7.35v-4.673ZM56.082 57.358h7.35v4.67h-7.35v-4.67ZM20.566 57.358h7.348v4.67h-7.348v-4.67Z",
    fill: "#B1E4F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.566 37.712h7.348v1.729h-7.348v-1.73ZM20.566 47.533h7.348v1.729h-7.348v-1.729ZM20.566 57.358h7.348v1.726h-7.348v-1.726ZM56.082 57.358h7.35v1.726h-7.35v-1.726ZM56.082 47.533h7.35v1.729h-7.35v-1.729ZM56.082 37.712h7.35v1.729h-7.35v-1.73Z",
    fill: "#75CEF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.645 25.972h15.73c1.526 0 2.025-.152 2.025 1.464v39.159h2.957V23.466H31.645v2.506Z",
    fill: "#FFF8ED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.484 28.991v4.06h2.16V28.992h-2.16Z",
    fill: "#FFD76F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.113 19.405H30.578a2.039 2.039 0 0 0-2.035 2.03c0 1.117.916 2.03 2.035 2.03H53.113a2.039 2.039 0 0 0 2.035-2.03c0-1.116-.916-2.03-2.035-2.03Z",
    fill: "#FFC26F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.156 19.405a2.04 2.04 0 0 1 2.035 2.03 2.04 2.04 0 0 1-2.035 2.03H53.113a2.039 2.039 0 0 0 2.035-2.03c0-1.116-.916-2.03-2.035-2.03h-2.957Z",
    fill: "#FFD76F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.984 54.1h6.014v12.495h-6.014V54.1Z",
    fill: "#B1E4F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.998 54.1h6.017v12.495h-6.017V54.1Z",
    fill: "#B1E4F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.984 55.782h6.014V54.1h-6.014v1.682Z",
    fill: "#75CEF8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.998 54.1v1.682h3.521c.97 0 .767.286.767 1.306v9.507h1.73V54.1h-6.018Z",
    fill: "#75CEF8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.697 29.105h-3.396a.295.295 0 0 0-.293.296v3.124h-3.132a.296.296 0 0 0-.296.296v3.389c0 .161.131.292.296.292h3.132v3.128c0 .161.13.292.293.292h3.396c.162 0 .296-.13.296-.292v-3.128h3.132c.162 0 .296-.13.296-.292v-3.39a.298.298 0 0 0-.296-.295h-3.132v-3.124a.298.298 0 0 0-.296-.296Z",
    fill: "#FFC26F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.696 29.105h-2.471c.567 1.288.91 2.96.91 4.785 0 2.497-.639 4.701-1.617 6.032h3.178c.162 0 .296-.13.296-.292v-3.128h3.132c.162 0 .296-.13.296-.292v-3.39a.298.298 0 0 0-.296-.294h-3.132V29.4a.298.298 0 0 0-.296-.296Z",
    fill: "#FFD76F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.255 47.533a.82.82 0 0 0-.82-.82h-7.351a.82.82 0 0 0-.82.82v4.673c0 .453.367.82.82.82h7.35a.82.82 0 0 0 .821-.82v-4.673Zm-1.64 3.853h-5.71v-3.033h5.71v3.033ZM63.435 56.538h-7.351a.82.82 0 0 0-.82.82v4.67c0 .453.367.82.82.82h7.35a.82.82 0 0 0 .821-.82v-4.67a.82.82 0 0 0-.82-.82Zm-.82 4.67h-5.71v-3.03h5.71v3.03Z",
    fill: "#303030"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70 31.02c0-1.57-1.28-2.85-2.855-2.85H53.177v-3.886a2.855 2.855 0 0 0 2.791-2.848c0-1.572-1.28-2.851-2.855-2.851H30.578a2.856 2.856 0 0 0-2.855 2.85c0 1.572 1.28 2.851 2.855 2.851h.245v3.884H16.855A2.856 2.856 0 0 0 14 31.02c0 1.281.85 2.367 2.016 2.726v32.85c0 .453.367.82.82.82h50.328a.82.82 0 0 0 .82-.82V51.201a.82.82 0 1 0-1.64 0v14.573H53.176V33.871h13.166v13.532a.82.82 0 1 0 1.641 0V33.746A2.856 2.856 0 0 0 70 31.02Zm-40.636-9.584c0-.668.544-1.21 1.214-1.21h22.536c.67 0 1.214.542 1.214 1.21 0 .667-.545 1.21-1.215 1.21H30.579c-.67 0-1.214-.543-1.214-1.21ZM15.64 31.02c0-.667.544-1.21 1.214-1.21h13.969v2.42H16.855c-.67 0-1.214-.543-1.214-1.21Zm2.016 2.85h13.167v31.904H17.657V33.871Zm14.807-9.585h19.072v41.49h-2.7V54.1a.82.82 0 0 0-.82-.82H35.983a.82.82 0 0 0-.82.82v11.675h-2.7V24.286ZM42.82 54.92h4.376v10.855H42.82V54.92Zm-1.641 10.855h-4.373V54.92h4.373v10.855Zm25.967-33.544H53.177v-2.42h13.968c.67 0 1.215.543 1.215 1.21 0 .667-.545 1.21-1.215 1.21Z",
    fill: "#303030"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.914 36.892h-7.348a.82.82 0 0 0-.82.82v4.673c0 .453.367.82.82.82h7.348a.82.82 0 0 0 .82-.82v-4.673a.82.82 0 0 0-.82-.82Zm-.82 4.673h-5.707v-3.033h5.707v3.033ZM27.914 46.713h-7.348a.82.82 0 0 0-.82.82v4.673c0 .453.367.82.82.82h7.348a.82.82 0 0 0 .82-.82v-4.673a.82.82 0 0 0-.82-.82Zm-.82 4.673h-5.707v-3.033h5.707v3.033ZM27.914 56.538h-7.348a.82.82 0 0 0-.82.82v4.67c0 .453.367.82.82.82h7.348a.82.82 0 0 0 .82-.82v-4.67a.82.82 0 0 0-.82-.82Zm-.82 4.67h-5.707v-3.03h5.707v3.03ZM64.255 37.712a.82.82 0 0 0-.82-.82h-7.351a.82.82 0 0 0-.82.82v4.673c0 .453.367.82.82.82h7.35a.82.82 0 0 0 .821-.82v-4.673Zm-1.64 3.853h-5.71v-3.033h5.71v3.033ZM36.876 37.322h2.312v2.308c0 .613.499 1.112 1.113 1.112h3.396c.616 0 1.116-.499 1.116-1.112v-2.308h2.312c.615 0 1.116-.499 1.116-1.112v-3.39c0-.614-.5-1.115-1.116-1.115h-2.312v-2.304c0-.616-.5-1.116-1.116-1.116h-3.396c-.614 0-1.114.5-1.114 1.116v2.304h-2.31c-.616 0-1.117.5-1.117 1.116v3.389c0 .613.5 1.112 1.116 1.112Zm.524-3.976h2.608a.82.82 0 0 0 .82-.82v-2.6h2.345v2.6c0 .452.367.82.82.82h2.608v2.336h-2.608a.82.82 0 0 0-.82.82v2.6h-2.345v-2.6a.82.82 0 0 0-.82-.82H37.4v-2.336ZM45.466 43.337h-6.933a.82.82 0 1 0 0 1.64h6.933a.82.82 0 1 0 0-1.64ZM45.466 47.21h-6.933a.82.82 0 1 0 0 1.642h6.933a.82.82 0 0 0 0-1.641Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppointmentClinicsPlaceholder);
export default __webpack_public_path__ + "static/media/icon_appointment_clinics_placeholder.41625a20.svg";
export { ForwardRef as ReactComponent };